<template>
<VueSlickgrid
  :name="gridName"
  :headerTitle="messages.title"
  :items="ds"
  checkbox-row-selection
  export-to-csv
  :exportToCsvFilename="messages.exportFilename"
  footer-totals
  :columnDefaults="b_7315092382398562_columnDefaults"
  :columns="b_7315092382398562_columns"
  ref="grid"
  @selectedRowsChanged="evh_7315092382398562_selectedRowsChanged($event, {})"
  @command="evh_7315092382398562_command($event, {})"
>
  <DIV
    class="flex-grow-1 d-flex border-left px-3"
    slot="toolbar"
  >
    <b-dropdown
      size="sm"
      toggle-class="btn-light border"
    >
      <template
        slot="button-content"
      >
        <ItpIcon
          :icon="$config.billingList.createItemIcon"
          class="mx-1"
        >
        </ItpIcon>
        <ItpText
          :text="'Billing plan'|pgettext('BillingList')"
        >
        </ItpText>
      </template>
      <ItpNavItem
        :icon="$config.billingList.createItemIcon"
        :text="'Create billing plan...'|pgettext('BillingList')"
        size="sm"
        dropdown-item
        @click="evh_8320016629450276_click($event, {})"
      >
      </ItpNavItem>
      <ItpNavItem
        :icon="$config.billingList.createItemIcon"
        :text="'Add item...'|pgettext('BillingList')"
        size="sm"
        dropdown-item
        @click="evh_6705964765214521_click($event, {})"
      >
      </ItpNavItem>
      <ItpNavItem
        :icon="$config.billingList.createItemIcon"
        :text="'Copy items...'|pgettext('BillingList')"
        size="sm"
        :disabled="!selectedItems || !selectedItems.length"
        dropdown-item
        @click="evh_6806515264385235_click($event, {})"
      >
      </ItpNavItem>
      <ItpNavItem
        icon="fa-trash"
        :text="'Delete'|gettext"
        size="sm"
        :disabled="!selectedItems || !selectedItems.length"
        :spinning="actions.deleteItems.isRunning"
        dropdown-item
        @click="evh_8116269939469002_click($event, {})"
      >
      </ItpNavItem>
      <ItpNavItem
        :icon="$config.billingList.createItemIcon"
        :text="'Bulk edit...'|pgettext('BillingList')"
        size="sm"
        :disabled="!selectedItems || !selectedItems.length"
        :spinning="actions.deleteItems.isRunning"
        dropdown-item
        @click="evh_5900129514656303_click($event, {})"
      >
      </ItpNavItem>
      <ItpNavItem
        :icon="$config.uploadIcon"
        :text="'Bulk upload...'|pgettext('BillingList')"
        size="sm"
        dropdown-item
        @click="evh_1655522927138420_click($event, {})"
      >
      </ItpNavItem>
    </b-dropdown>
    <JobHandlerControl
      size="sm"
      jobType="invoice_generation_from_billing_list"
      load-current
      :payload="onCreateInvoicesPayload"
      icon="mdi:cog"
      :text="'Generate invoices'|pgettext('BillingList|Submit')"
      :disabled="!selectedItems || !selectedItems.length"
      class="ml-3"
      @success="evh_3343864469950044_success($event, {})"
    >
    </JobHandlerControl>
    <ItpButton
      :icon="$config.mergeIcon"
      :text="'Merge invoices'|gettext"
      size="sm"
      variant="light"
      :disabled="!selectedItems || !selectedItems.length"
      :spinning="actions.mergeInvoices.isRunning"
      class="ml-3"
      @click="evh_1889980785424776_click($event, {})"
    >
    </ItpButton>
    <ItpButton
      icon="fa-trash"
      :text="'Delete invoices'|gettext"
      size="sm"
      variant="light"
      :disabled="!selectedItems || !selectedItems.length"
      :spinning="actions.deleteInvoices.isRunning"
      class="ml-3"
      @click="evh_4892266742011185_click($event, {})"
    >
    </ItpButton>
    <ArtifactJob
      icon="ic:baseline-download"
      :text="'Download views'|gettext"
      size="sm"
      :disabled="!selectedItems || !selectedItems.length"
      operation="download_invoice_views"
      :payload="boundDownloadViewsPayloadMethod()"
      class="ml-3"
    >
    </ArtifactJob>
  </DIV>
</VueSlickgrid>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcBillingList extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  getQueryParameters(...args: any[]) {
    return {
      company_id: this.companyId,
      client_id: this.clientId,
      rental_id: this.rentalId,
      contract_id: this.contractId,
    }
  }

  onCreateInvoicesPayload(...args: any[]) {
    return {
      items: this.selectedItems.map(p => ({ id: p.id }))
    };

    return this.$imodal
      .show({ name: 'CompleteInvoicesAlt' })
      .then(result => {
        if (!result || result.cancel || !result.value) {
          return;
        }
        return this.selectedItems.map(p => ({
          ...result.value,
          invoice_id: p.id,
        }));
      }
      )
  }

  onCreateBillingPlan(...args: any[]) {
    return {
      items: this.selectedItems.map(p => ({ id: p.id }))
    };

    return this.$imodal
      .show({ name: 'CreateBillingPlan' })
      .then(result => {
        if (!result || result.cancel || !result.value) {
          return;
        }
        return this.selectedItems.map(p => ({
          ...result.value,
          invoice_id: p.id,
        }));
      }
      )
  }

  getDownloadViewsPayload(...args: any[]) {
    return {
      identities: _.chain(this.selectedItems)
        .filter(p => p.invoice && p.invoice.id)
        .map(p => p.invoice.id)
        .uniq()
        .value()
    }
  }

  boundDownloadViewsPayloadMethod(...args: any[]) {
    if (!this._getDownloadViewsPayload) {
      this._getDownloadViewsPayload = this.getDownloadViewsPayload.bind(this);
    }
    return this._getDownloadViewsPayload
  }

  @Prop({
    type: String,
  })
  companyId!: string;

  @Watch('companyId')
  onCompany_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("companyId")
  }

  @Prop({
    type: String,
  })
  clientId!: string;

  @Watch('clientId')
  onClient_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("clientId")
  }

  @Prop({
    type: String,
  })
  rentalId!: string;

  @Watch('rentalId')
  onRental_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("rentalId")
  }

  @Prop({
    type: String,
  })
  contractId!: string;

  @Watch('contractId')
  onContract_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("contractId")
  }

  gridName!: any;
  messages!: any;
  selectedItems!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('list_billing_list_item', { parameters: this.getQueryParameters })
  }

  ux!: any;
  b_7315092382398562_columnDefaults!: any;
  b_7315092382398562_columns!: any;
  dataMembers = ['gridName', 'messages', 'selectedItems', 'ds', 'ux', 'b_7315092382398562_columnDefaults', 'b_7315092382398562_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        gridName: "billingList",
        messages: {
          title: this.$fn.pgettext("billingList|Title", "Billing list"),
          exportFilename: this.$fn.pgettext("billingList|Export|Filename", "billing-list"),
        }
        ,
        selectedItems: [
        ]
        ,
        ds: null,
        ux: null,
        b_7315092382398562_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
          selectable: true,
        }
        ,
        b_7315092382398562_columns: [{
          field: "invoice_date",
          name: this.$fn.pgettext("BillingList", "Billing due date"),
          type: "date",
        }
          ,
        {
          field: "invoice",
          name: this.$fn.pgettext("BillingList", "Invoice"),
          params: {
            sortPath: "invoice.invoice_number",
          }
          ,
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <a href=\"#\" onclick=\"return false;\">\n\
      <strong title=\"{{ $value.invoice_number }}\">{{ $value.invoice_number }}</strong>\n\
    </a>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "due_date",
          name: this.$fn.pgettext("BillingList", "Payment due date"),
          type: "date",
        }
          ,
        {
          name: this.$fn.pgettext("BillingList", "Period start"),
          params: {
            sortPath: "period.start",
          }
          ,
          field: "period.start",
          type: "date",
          formatter: [{
            name: "getvalue",
            opts: {
              field: "period.start",
            }
            ,
          }
            ,
          ]
          ,
        }
          ,
        {
          name: this.$fn.pgettext("BillingList", "Period end"),
          params: {
            sortPath: "period.end",
          }
          ,
          field: "period.end",
          type: "date",
          formatter: [{
            name: "getvalue",
            opts: {
              field: "period.end",
            }
            ,
          }
            ,
          ]
          ,
        }
          ,
        {
          field: "company",
          name: this.$fn.pgettext("BillingList", "Company"),
          width: "100px",
          params: {
            sortPath: "company.code",
          }
          ,
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "company",
              navigateOnIconClick: true,
              params: {
                id: "company.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "partner",
          name: this.$fn.pgettext("BillingList", "Partner"),
          width: "100px",
          params: {
            sortPath: "partner.code",
          }
          ,
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "company",
              navigateOnIconClick: true,
              params: {
                id: "partner.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "contract",
          name: this.$fn.pgettext("BillingList", "Contract"),
          params: {
            sortPath: "contract.contract_number",
          }
          ,
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.contract_number }}\">{{ $value.contract_number }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "contract",
              navigateOnIconClick: true,
              params: {
                id: "contract.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "rental",
          name: this.$fn.pgettext("BillingList", "Rental"),
          params: {
            sortPath: "rental.name",
          }
          ,
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.name }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "rental",
              navigateOnIconClick: true,
              params: {
                id: "rental.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "description",
          name: this.$fn.pgettext("BillingList", "Description"),
          type: "command",
        }
          ,
        {
          field: "billing_category",
          name: this.$fn.pgettext("BillingList", "Billing category"),
        }
          ,
        {
          field: "notes",
          name: this.$fn.pgettext("BillingList", "Notes"),
        }
          ,
        {
          field: "quantity",
          name: this.$fn.pgettext("BillingList", "Quantity"),
          type: "number",
          formatter: "number",
        }
          ,
        {
          field: "unit",
          name: this.$fn.pgettext("BillingList", "Unit"),
        }
          ,
        {
          field: "unit_price",
          name: this.$fn.pgettext("BillingList", "Price"),
          type: "number",
          formatter: "number",
        }
          ,
        {
          field: "currency",
          name: this.$fn.pgettext("BillingList", "Currency"),
        }
          ,
        {
          field: "discount",
          name: this.$fn.pgettext("BillingList", "Discount"),
          type: "number",
          formatter: "number",
        }
          ,
        {
          field: "net_amount",
          name: this.$fn.pgettext("BillingList", "Net"),
          type: "number",
          formatter: "number",
        }
          ,
        {
          field: "tax_code",
          name: this.$fn.pgettext("BillingList", "Tax code"),
        }
          ,
        {
          field: "exchange_rate",
          name: this.$fn.pgettext("BillingList", "Exchrate"),
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <span title=\"{{ $value.value }}\">{{ $value.value }}</span>\n\
\n\
    {{~#if $value.date }}\n\
      <span>&middot; {{ $value.date }}</span>\n\
    {{~/if }}\n\
\n\
    {{~#if $value.source }}\n\
      <span>&middot; {{ $value.source }}</span>\n\
    {{~/if }}\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "intermediated_service",
          name: this.$fn.pgettext("BillingList", "Intermediated Service"),
          formatter: "checkmark",
        }
          ,
        {
          field: "created_at",
          name: this.$fn.pgettext("BrowserColumn", "Create time"),
          formatter: "datetime",
        }
          ,
        ]
        ,
      },
    }
  }

  async act_7315092382398562_setData_2242_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_7315092382398562_setData_2242, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_7315092382398562_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_7315092382398562_showModal_2244_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_7315092382398562_showModal_2244, alias=undefined
    return {
      name: "Invoice",
      props: {
        oid: $event.data.data.invoice.id,
        modal: true,
      }
      ,
    }
  }

  async evh_7315092382398562_command_2243_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_7315092382398562_command_2243, alias=undefined
    return $event.data.column.id === 'invoice'
  }

  async act_7315092382398562_reloadSlickgrid_2248_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_7315092382398562_reloadSlickgrid_2248, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_7315092382398562_close_2247_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_7315092382398562_close_2247, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_7315092382398562_showModal_2246_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_7315092382398562_showModal_2246, alias=undefined
    return {
      name: "BillingListItem",
      props: {
        oid: $event.data.data.id,
      }
      ,
    }
  }

  async evh_7315092382398562_command_2245_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_7315092382398562_command_2245, alias=undefined
    return $event.data.column.id === 'description'
  }

  async evh_7315092382398562_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_command.executeFromDOM(this, event, scope);
  }

  async act_8320016629450276_reloadSlickgrid_2252_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_8320016629450276_reloadSlickgrid_2252, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_8320016629450276_close_2251_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_8320016629450276_close_2251, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_8320016629450276_showModal_2250_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8320016629450276_showModal_2250, alias=undefined
    return {
      name: "CreateBillingPlan",
    }
  }

  async evh_8320016629450276_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_click.executeFromDOM(this, event, scope);
  }

  async act_6705964765214521_reloadSlickgrid_2256_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_6705964765214521_reloadSlickgrid_2256, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_6705964765214521_close_2255_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_6705964765214521_close_2255, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_6705964765214521_showModal_2254_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_6705964765214521_showModal_2254, alias=undefined
    return {
      name: "BillingListItem",
    }
  }

  async evh_6705964765214521_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6705964765214521_click.executeFromDOM(this, event, scope);
  }

  async act_6806515264385235_reloadSlickgrid_2260_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_6806515264385235_reloadSlickgrid_2260, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_6806515264385235_close_2259_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_6806515264385235_close_2259, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_6806515264385235_showModal_2258_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_6806515264385235_showModal_2258, alias=undefined
    return {
      name: "CopyBillingListItems",
      props: {
        sources: _.map(this.selectedItems, 'id'),
      }
      ,
    }
  }

  async evh_6806515264385235_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6806515264385235_click.executeFromDOM(this, event, scope);
  }

  async act_8116269939469002_reloadSlickgrid_2264_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_8116269939469002_reloadSlickgrid_2264, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async act_8116269939469002_request_2262_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_8116269939469002_request_2262, alias=deleteItems
    return {
      operation: "delete_many_billing_list_item",
      data: { items: this.selectedItems.map(p => p.id) },
    }
  }

  async evh_8116269939469002_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8116269939469002_click.executeFromDOM(this, event, scope);
  }

  async act_5900129514656303_reloadSlickgrid_2268_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_5900129514656303_reloadSlickgrid_2268, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_5900129514656303_close_2267_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_5900129514656303_close_2267, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_5900129514656303_showModal_2266_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_5900129514656303_showModal_2266, alias=undefined
    return {
      name: "BatchBillingListEditor",
      props: {
        items: this.selectedItems,
      }
      ,
    }
  }

  async evh_5900129514656303_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5900129514656303_click.executeFromDOM(this, event, scope);
  }

  async act_1655522927138420_reloadSlickgrid_2272_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_1655522927138420_reloadSlickgrid_2272, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_1655522927138420_close_2271_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1655522927138420_close_2271, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_1655522927138420_showModal_2270_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_1655522927138420_showModal_2270, alias=undefined
    return {
      name: "UploadBillingListItems",
    }
  }

  async evh_1655522927138420_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1655522927138420_click.executeFromDOM(this, event, scope);
  }

  async act_3343864469950044_reloadSlickgrid_2274_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_3343864469950044_reloadSlickgrid_2274, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_3343864469950044_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3343864469950044_success.executeFromDOM(this, event, scope);
  }

  async act_1889980785424776_reloadSlickgrid_2278_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_1889980785424776_reloadSlickgrid_2278, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async act_1889980785424776_request_2276_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1889980785424776_request_2276, alias=mergeInvoices
    return {
      operation: "merge_invoices",
      data: {
        items: _.chain(this.selectedItems)
          .filter(p => _.get(p, 'invoice.id') != null)
          .map(p => p.invoice.id)
          .uniq()
          .value()
      },
    }
  }

  async evh_1889980785424776_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1889980785424776_click.executeFromDOM(this, event, scope);
  }

  async act_4892266742011185_reloadSlickgrid_2282_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_4892266742011185_reloadSlickgrid_2282, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async act_4892266742011185_request_2280_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_4892266742011185_request_2280, alias=deleteInvoices
    return {
      operation: "delete_draft_invoices",
      data: {
        invoices: _.chain(this.selectedItems)
          .filter(p => _.get(p, 'invoice.id') != null)
          .map(p => p.invoice.id)
          .uniq()
          .value()
      },
    }
  }

  async evh_4892266742011185_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4892266742011185_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_setData_2242: actions.SetDataAction;
    evh_7315092382398562_selectedRowsChanged_2241: actions.EventHandlerImpl;
    evh_7315092382398562_selectedRowsChanged: actions.EventHandlerGroup;
    act_7315092382398562_showModal_2244: actions.ShowModalAction;
    evh_7315092382398562_command_2243: actions.EventHandlerImpl;
    act_7315092382398562_reloadSlickgrid_2248: actions.ReloadSlickgridAction;
    evh_7315092382398562_close_2247: actions.EventHandlerImpl;
    act_7315092382398562_showModal_2246: actions.ShowModalAction;
    evh_7315092382398562_command_2245: actions.EventHandlerImpl;
    evh_7315092382398562_command: actions.EventHandlerGroup;
    act_8320016629450276_reloadSlickgrid_2252: actions.ReloadSlickgridAction;
    evh_8320016629450276_close_2251: actions.EventHandlerImpl;
    act_8320016629450276_showModal_2250: actions.ShowModalAction;
    evh_8320016629450276_click_2249: actions.EventHandlerImpl;
    evh_8320016629450276_click: actions.EventHandlerGroup;
    act_6705964765214521_reloadSlickgrid_2256: actions.ReloadSlickgridAction;
    evh_6705964765214521_close_2255: actions.EventHandlerImpl;
    act_6705964765214521_showModal_2254: actions.ShowModalAction;
    evh_6705964765214521_click_2253: actions.EventHandlerImpl;
    evh_6705964765214521_click: actions.EventHandlerGroup;
    act_6806515264385235_reloadSlickgrid_2260: actions.ReloadSlickgridAction;
    evh_6806515264385235_close_2259: actions.EventHandlerImpl;
    act_6806515264385235_showModal_2258: actions.ShowModalAction;
    evh_6806515264385235_click_2257: actions.EventHandlerImpl;
    evh_6806515264385235_click: actions.EventHandlerGroup;
    act_8116269939469002_reloadSlickgrid_2264: actions.ReloadSlickgridAction;
    evh_8116269939469002_success_2263: actions.EventHandlerImpl;
    act_8116269939469002_request_2262: actions.RequestAction;
    evh_8116269939469002_click_2261: actions.EventHandlerImpl;
    evh_8116269939469002_click: actions.EventHandlerGroup;
    act_5900129514656303_reloadSlickgrid_2268: actions.ReloadSlickgridAction;
    evh_5900129514656303_close_2267: actions.EventHandlerImpl;
    act_5900129514656303_showModal_2266: actions.ShowModalAction;
    evh_5900129514656303_click_2265: actions.EventHandlerImpl;
    evh_5900129514656303_click: actions.EventHandlerGroup;
    act_1655522927138420_reloadSlickgrid_2272: actions.ReloadSlickgridAction;
    evh_1655522927138420_close_2271: actions.EventHandlerImpl;
    act_1655522927138420_showModal_2270: actions.ShowModalAction;
    evh_1655522927138420_click_2269: actions.EventHandlerImpl;
    evh_1655522927138420_click: actions.EventHandlerGroup;
    act_3343864469950044_reloadSlickgrid_2274: actions.ReloadSlickgridAction;
    evh_3343864469950044_success_2273: actions.EventHandlerImpl;
    evh_3343864469950044_success: actions.EventHandlerGroup;
    act_1889980785424776_reloadSlickgrid_2278: actions.ReloadSlickgridAction;
    evh_1889980785424776_success_2277: actions.EventHandlerImpl;
    act_1889980785424776_request_2276: actions.RequestAction;
    evh_1889980785424776_click_2275: actions.EventHandlerImpl;
    evh_1889980785424776_click: actions.EventHandlerGroup;
    act_4892266742011185_reloadSlickgrid_2282: actions.ReloadSlickgridAction;
    evh_4892266742011185_success_2281: actions.EventHandlerImpl;
    act_4892266742011185_request_2280: actions.RequestAction;
    evh_4892266742011185_click_2279: actions.EventHandlerImpl;
    evh_4892266742011185_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_setData_2242 = new actions.SetDataAction(
      {
        actionArgs: this.act_7315092382398562_setData_2242_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_selectedRowsChanged_2241 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_setData_2242,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_7315092382398562_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_selectedRowsChanged_2241],
      }
    );
    const act_7315092382398562_showModal_2244 = new actions.ShowModalAction(
      {
        actionArgs: this.act_7315092382398562_showModal_2244_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_command_2243 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_showModal_2244,
        event: "command",
        when: this.evh_7315092382398562_command_2243_getWhen,
        displayName: "showModal",
      }
    );
    const act_7315092382398562_reloadSlickgrid_2248 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_7315092382398562_reloadSlickgrid_2248_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2247 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadSlickgrid_2248,
        event: "close",
        when: this.evh_7315092382398562_close_2247_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_7315092382398562_showModal_2246 = new actions.ShowModalAction(
      {
        actionArgs: this.act_7315092382398562_showModal_2246_getActionArgs,
        events: [evh_7315092382398562_close_2247],
      }
    );
    const evh_7315092382398562_command_2245 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_showModal_2246,
        event: "command",
        when: this.evh_7315092382398562_command_2245_getWhen,
        displayName: "showModal",
      }
    );
    const evh_7315092382398562_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_command_2243, evh_7315092382398562_command_2245],
      }
    );
    const act_8320016629450276_reloadSlickgrid_2252 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_8320016629450276_reloadSlickgrid_2252_getActionArgs,
        events: [],
      }
    );
    const evh_8320016629450276_close_2251 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_reloadSlickgrid_2252,
        event: "close",
        when: this.evh_8320016629450276_close_2251_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_8320016629450276_showModal_2250 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8320016629450276_showModal_2250_getActionArgs,
        events: [evh_8320016629450276_close_2251],
      }
    );
    const evh_8320016629450276_click_2249 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_showModal_2250,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_8320016629450276_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_click_2249],
      }
    );
    const act_6705964765214521_reloadSlickgrid_2256 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_6705964765214521_reloadSlickgrid_2256_getActionArgs,
        events: [],
      }
    );
    const evh_6705964765214521_close_2255 = new actions.EventHandlerImpl(
      {
        action: act_6705964765214521_reloadSlickgrid_2256,
        event: "close",
        when: this.evh_6705964765214521_close_2255_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_6705964765214521_showModal_2254 = new actions.ShowModalAction(
      {
        actionArgs: this.act_6705964765214521_showModal_2254_getActionArgs,
        events: [evh_6705964765214521_close_2255],
      }
    );
    const evh_6705964765214521_click_2253 = new actions.EventHandlerImpl(
      {
        action: act_6705964765214521_showModal_2254,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_6705964765214521_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_6705964765214521_click_2253],
      }
    );
    const act_6806515264385235_reloadSlickgrid_2260 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_6806515264385235_reloadSlickgrid_2260_getActionArgs,
        events: [],
      }
    );
    const evh_6806515264385235_close_2259 = new actions.EventHandlerImpl(
      {
        action: act_6806515264385235_reloadSlickgrid_2260,
        event: "close",
        when: this.evh_6806515264385235_close_2259_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_6806515264385235_showModal_2258 = new actions.ShowModalAction(
      {
        actionArgs: this.act_6806515264385235_showModal_2258_getActionArgs,
        events: [evh_6806515264385235_close_2259],
      }
    );
    const evh_6806515264385235_click_2257 = new actions.EventHandlerImpl(
      {
        action: act_6806515264385235_showModal_2258,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_6806515264385235_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_6806515264385235_click_2257],
      }
    );
    const act_8116269939469002_reloadSlickgrid_2264 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_8116269939469002_reloadSlickgrid_2264_getActionArgs,
        events: [],
      }
    );
    const evh_8116269939469002_success_2263 = new actions.EventHandlerImpl(
      {
        action: act_8116269939469002_reloadSlickgrid_2264,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_8116269939469002_request_2262 = new actions.RequestAction(
      {
        actionArgs: this.act_8116269939469002_request_2262_getActionArgs,
        displayName: "deleteItems",
        events: [evh_8116269939469002_success_2263],
      }
    );
    const evh_8116269939469002_click_2261 = new actions.EventHandlerImpl(
      {
        action: act_8116269939469002_request_2262,
        event: "click",
        displayName: "deleteItems",
      }
    );
    const evh_8116269939469002_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_8116269939469002_click_2261],
      }
    );
    const act_5900129514656303_reloadSlickgrid_2268 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_5900129514656303_reloadSlickgrid_2268_getActionArgs,
        events: [],
      }
    );
    const evh_5900129514656303_close_2267 = new actions.EventHandlerImpl(
      {
        action: act_5900129514656303_reloadSlickgrid_2268,
        event: "close",
        when: this.evh_5900129514656303_close_2267_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_5900129514656303_showModal_2266 = new actions.ShowModalAction(
      {
        actionArgs: this.act_5900129514656303_showModal_2266_getActionArgs,
        events: [evh_5900129514656303_close_2267],
      }
    );
    const evh_5900129514656303_click_2265 = new actions.EventHandlerImpl(
      {
        action: act_5900129514656303_showModal_2266,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_5900129514656303_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_5900129514656303_click_2265],
      }
    );
    const act_1655522927138420_reloadSlickgrid_2272 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_1655522927138420_reloadSlickgrid_2272_getActionArgs,
        events: [],
      }
    );
    const evh_1655522927138420_close_2271 = new actions.EventHandlerImpl(
      {
        action: act_1655522927138420_reloadSlickgrid_2272,
        event: "close",
        when: this.evh_1655522927138420_close_2271_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_1655522927138420_showModal_2270 = new actions.ShowModalAction(
      {
        actionArgs: this.act_1655522927138420_showModal_2270_getActionArgs,
        events: [evh_1655522927138420_close_2271],
      }
    );
    const evh_1655522927138420_click_2269 = new actions.EventHandlerImpl(
      {
        action: act_1655522927138420_showModal_2270,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_1655522927138420_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_1655522927138420_click_2269],
      }
    );
    const act_3343864469950044_reloadSlickgrid_2274 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_3343864469950044_reloadSlickgrid_2274_getActionArgs,
        events: [],
      }
    );
    const evh_3343864469950044_success_2273 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_reloadSlickgrid_2274,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const evh_3343864469950044_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_3343864469950044_success_2273],
      }
    );
    const act_1889980785424776_reloadSlickgrid_2278 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_1889980785424776_reloadSlickgrid_2278_getActionArgs,
        events: [],
      }
    );
    const evh_1889980785424776_success_2277 = new actions.EventHandlerImpl(
      {
        action: act_1889980785424776_reloadSlickgrid_2278,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_1889980785424776_request_2276 = new actions.RequestAction(
      {
        actionArgs: this.act_1889980785424776_request_2276_getActionArgs,
        displayName: "mergeInvoices",
        events: [evh_1889980785424776_success_2277],
      }
    );
    const evh_1889980785424776_click_2275 = new actions.EventHandlerImpl(
      {
        action: act_1889980785424776_request_2276,
        event: "click",
        displayName: "mergeInvoices",
      }
    );
    const evh_1889980785424776_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_1889980785424776_click_2275],
      }
    );
    const act_4892266742011185_reloadSlickgrid_2282 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_4892266742011185_reloadSlickgrid_2282_getActionArgs,
        events: [],
      }
    );
    const evh_4892266742011185_success_2281 = new actions.EventHandlerImpl(
      {
        action: act_4892266742011185_reloadSlickgrid_2282,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_4892266742011185_request_2280 = new actions.RequestAction(
      {
        actionArgs: this.act_4892266742011185_request_2280_getActionArgs,
        displayName: "deleteInvoices",
        events: [evh_4892266742011185_success_2281],
      }
    );
    const evh_4892266742011185_click_2279 = new actions.EventHandlerImpl(
      {
        action: act_4892266742011185_request_2280,
        event: "click",
        displayName: "deleteInvoices",
      }
    );
    const evh_4892266742011185_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_4892266742011185_click_2279],
      }
    );
    return {
      act_7315092382398562_setData_2242,
      evh_7315092382398562_selectedRowsChanged_2241,
      evh_7315092382398562_selectedRowsChanged,
      act_7315092382398562_showModal_2244,
      evh_7315092382398562_command_2243,
      act_7315092382398562_reloadSlickgrid_2248,
      evh_7315092382398562_close_2247,
      act_7315092382398562_showModal_2246,
      evh_7315092382398562_command_2245,
      evh_7315092382398562_command,
      act_8320016629450276_reloadSlickgrid_2252,
      evh_8320016629450276_close_2251,
      act_8320016629450276_showModal_2250,
      evh_8320016629450276_click_2249,
      evh_8320016629450276_click,
      act_6705964765214521_reloadSlickgrid_2256,
      evh_6705964765214521_close_2255,
      act_6705964765214521_showModal_2254,
      evh_6705964765214521_click_2253,
      evh_6705964765214521_click,
      act_6806515264385235_reloadSlickgrid_2260,
      evh_6806515264385235_close_2259,
      act_6806515264385235_showModal_2258,
      evh_6806515264385235_click_2257,
      evh_6806515264385235_click,
      act_8116269939469002_reloadSlickgrid_2264,
      evh_8116269939469002_success_2263,
      act_8116269939469002_request_2262,
      evh_8116269939469002_click_2261,
      evh_8116269939469002_click,
      act_5900129514656303_reloadSlickgrid_2268,
      evh_5900129514656303_close_2267,
      act_5900129514656303_showModal_2266,
      evh_5900129514656303_click_2265,
      evh_5900129514656303_click,
      act_1655522927138420_reloadSlickgrid_2272,
      evh_1655522927138420_close_2271,
      act_1655522927138420_showModal_2270,
      evh_1655522927138420_click_2269,
      evh_1655522927138420_click,
      act_3343864469950044_reloadSlickgrid_2274,
      evh_3343864469950044_success_2273,
      evh_3343864469950044_success,
      act_1889980785424776_reloadSlickgrid_2278,
      evh_1889980785424776_success_2277,
      act_1889980785424776_request_2276,
      evh_1889980785424776_click_2275,
      evh_1889980785424776_click,
      act_4892266742011185_reloadSlickgrid_2282,
      evh_4892266742011185_success_2281,
      act_4892266742011185_request_2280,
      evh_4892266742011185_click_2279,
      evh_4892266742011185_click,
      deleteItems: act_8116269939469002_request_2262,
      mergeInvoices: act_1889980785424776_request_2276,
      deleteInvoices: act_4892266742011185_request_2280,
    }
  }
}

Vue.component("UcBillingList", UcBillingList);

</script>